import Modal from "react-bootstrap/Modal";
import Button from "../common/Button";
import { useState } from "react";
import axios from "axios";
import LoaderIcon from "../../utils/loader";
import SuccessModal from "../../utils/successModalMsg";

const CareerApplicationForm = ({ show, onClose, role, role_id }) => {
    //Success Modal
    const [showSuccess, setShowSuccess] = useState(false);
    const handleClose = () => {
        // setFormError([])
        setShowSuccess(false);
    };
    const handleShow = () => setShowSuccess(true);

    // Form
    const [loading, setLoading] = useState(false);
    const [formError, setFormError] = useState([]);
    const [formData, setFormData] = useState({
        full_name: "",
        email: "",
        phone_number: "",
        qualification: "",
        years_of_experience: "",
    });

    const {
        full_name,
        email,
        phone_number,
        qualification,
        years_of_experience,
    } = formData;

    const onChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const [resumeInput, setResumeInput] = useState<any>(null);
    const [coverLetterInput, setCoverLetterInput] = useState<any>(null);

    const onFileInputChange = (e, setFileState) => {
        const file = e.target.files[0];

        // Check file type
        if (file && !file.type.includes("pdf")) {
            alert("PDF files only accepted");
            return;
        }

        // Check file size
        const maxSize = 1 * 1024 * 1024; //1mb
        if (file && file.size > maxSize) {
            alert("File exceeds 1mb");
            return;
        }

        setFileState(file);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        // declare the data fetching function
        const PostFormData = async () => {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Accept: "application/json",
                },
            };

            const body = new FormData();
            body.append("full_name", full_name);
            body.append("email", email);
            body.append("phone_number", phone_number);
            body.append("qualification", qualification);
            body.append("years_of_experience", years_of_experience);
            body.append("job", role_id);
            if (resumeInput) body.append("resume", resumeInput);
            if (coverLetterInput) body.append("cover_letter", coverLetterInput);

            try {
                const res = await axios.post(
                    `${process.env.REACT_APP_API_URL}/job-opening-application`,
                    body,
                    config
                );
                setLoading(false);
                if (res.status === 201) {
                    onClose();
                    handleShow();
                    setFormData({
                        full_name: "",
                        email: "",
                        phone_number: "",
                        qualification: "",
                        years_of_experience: "",
                    });
                    setCoverLetterInput(null);
                    setResumeInput(null);
                }
            } catch (err) {
                setLoading(false);
                setFormError(err.response.data);
            }
        };
        PostFormData();
    };

    return (
        <>
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body className="!cht-p-6 sm:!cht-p-8 !cht-font-body">
                    <h3 className="cht-text-xl sm:cht-text-2xl cht-font-bold !cht-font-heading cht-text-[#1e293b] cht-mb-6">
                        Apply for Role: <span className="cht-text-[#3e57da]">{role}</span>
                    </h3>
                    <form className="cht-space-y-4" onSubmit={(e) => onSubmit(e)}>
                        <div>
                            <label htmlFor="full_name" className="cht-block cht-text-xs cht-font-semibold cht-text-slate-700 cht-mb-1.5 cht-uppercase cht-tracking-wider">
                                Full Name
                            </label>
                            <input
                                type="text"
                                className="cht-w-full cht-px-4 cht-py-2.5 cht-rounded-xl cht-border cht-border-slate-300 cht-bg-white cht-text-[#1e293b] cht-text-sm focus:cht-outline-none focus:cht-ring-2 focus:cht-ring-[#3e57da]/40 focus:cht-border-[#3e57da] cht-transition-all"
                                id="full_name"
                                placeholder="e.g. Jane Doe"
                                name="full_name"
                                onChange={(e) => onChange(e)}
                                value={full_name}
                                required
                            />
                        </div>

                        <div className="cht-grid sm:cht-grid-cols-2 cht-gap-4">
                            <div>
                                <label htmlFor="phone_number" className="cht-block cht-text-xs cht-font-semibold cht-text-slate-700 cht-mb-1.5 cht-uppercase cht-tracking-wider">
                                    Phone Number
                                </label>
                                <input
                                    type="text"
                                    className="cht-w-full cht-px-4 cht-py-2.5 cht-rounded-xl cht-border cht-border-slate-300 cht-bg-white cht-text-[#1e293b] cht-text-sm focus:cht-outline-none focus:cht-ring-2 focus:cht-ring-[#3e57da]/40 focus:cht-border-[#3e57da] cht-transition-all"
                                    id="phone_number"
                                    placeholder="+234..."
                                    name="phone_number"
                                    onChange={(e) => onChange(e)}
                                    value={phone_number}
                                    required
                                />
                            </div>

                            <div>
                                <label htmlFor="email" className="cht-block cht-text-xs cht-font-semibold cht-text-slate-700 cht-mb-1.5 cht-uppercase cht-tracking-wider">
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    className="cht-w-full cht-px-4 cht-py-2.5 cht-rounded-xl cht-border cht-border-slate-300 cht-bg-white cht-text-[#1e293b] cht-text-sm focus:cht-outline-none focus:cht-ring-2 focus:cht-ring-[#3e57da]/40 focus:cht-border-[#3e57da] cht-transition-all"
                                    id="email"
                                    placeholder="name@domain.com"
                                    name="email"
                                    onChange={(e) => onChange(e)}
                                    value={email}
                                    required
                                />
                            </div>
                        </div>

                        <div className="cht-grid sm:cht-grid-cols-2 cht-gap-4">
                            <div>
                                <label htmlFor="qualification" className="cht-block cht-text-xs cht-font-semibold cht-text-slate-700 cht-mb-1.5 cht-uppercase cht-tracking-wider">
                                    Highest Qualification
                                </label>
                                <input
                                    type="text"
                                    className="cht-w-full cht-px-4 cht-py-2.5 cht-rounded-xl cht-border cht-border-slate-300 cht-bg-white cht-text-[#1e293b] cht-text-sm focus:cht-outline-none focus:cht-ring-2 focus:cht-ring-[#3e57da]/40 focus:cht-border-[#3e57da] cht-transition-all"
                                    id="qualification"
                                    placeholder="B.Sc, HND, M.Sc, etc."
                                    name="qualification"
                                    onChange={(e) => onChange(e)}
                                    value={qualification}
                                    required
                                />
                            </div>

                            <div>
                                <label htmlFor="years_of_experience" className="cht-block cht-text-xs cht-font-semibold cht-text-slate-700 cht-mb-1.5 cht-uppercase cht-tracking-wider">
                                    Years of Experience
                                </label>
                                <input
                                    type="number"
                                    className="cht-w-full cht-px-4 cht-py-2.5 cht-rounded-xl cht-border cht-border-slate-300 cht-bg-white cht-text-[#1e293b] cht-text-sm focus:cht-outline-none focus:cht-ring-2 focus:cht-ring-[#3e57da]/40 focus:cht-border-[#3e57da] cht-transition-all"
                                    id="years_of_experience"
                                    placeholder="e.g. 3"
                                    name="years_of_experience"
                                    onChange={(e) => onChange(e)}
                                    value={years_of_experience}
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="cover_letter" className="cht-block cht-text-xs cht-font-semibold cht-text-slate-700 cht-mb-1.5 cht-uppercase cht-tracking-wider">
                                Cover Letter (PDF, max 1MB)
                            </label>
                            <input
                                className="cht-w-full cht-text-sm cht-text-slate-500 file:cht-mr-4 file:cht-py-2 file:cht-px-4 file:cht-rounded-xl file:cht-border-0 file:cht-text-xs file:cht-font-semibold file:cht-bg-[#3e57da]/10 file:cht-text-[#3e57da] hover:file:cht-bg-[#3e57da]/20"
                                type="file"
                                id="cover_letter"
                                accept=".pdf"
                                onChange={(e) =>
                                    onFileInputChange(e, setCoverLetterInput)
                                }
                                required
                            />
                        </div>

                        <div>
                            <label htmlFor="resume" className="cht-block cht-text-xs cht-font-semibold cht-text-slate-700 cht-mb-1.5 cht-uppercase cht-tracking-wider">
                                Resume / CV (PDF, max 1MB)
                            </label>
                            <input
                                className="cht-w-full cht-text-sm cht-text-slate-500 file:cht-mr-4 file:cht-py-2 file:cht-px-4 file:cht-rounded-xl file:cht-border-0 file:cht-text-xs file:cht-font-semibold file:cht-bg-[#3e57da]/10 file:cht-text-[#3e57da] hover:file:cht-bg-[#3e57da]/20"
                                type="file"
                                id="resume"
                                accept=".pdf"
                                onChange={(e) =>
                                    onFileInputChange(e, setResumeInput)
                                }
                                required
                            />
                        </div>

                        <div className="cht-flex cht-items-center cht-justify-end cht-gap-3 cht-pt-6 cht-border-t cht-border-slate-100">
                            <Button
                                type="button"
                                variant="subtle"
                                size="md"
                                onClick={onClose}
                            >
                                Cancel
                            </Button>

                            <Button
                                type="submit"
                                variant="primary"
                                size="md"
                                isLoading={loading}
                            >
                                Submit Application
                            </Button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            {showSuccess && (
                <SuccessModal
                    message={`You have Sucessfully applied for the position of ${role}. Do NOT apply more than once.`}
                    errorMessage={formError}
                    show={showSuccess}
                    onClose={handleClose}
                />
            )}
        </>
    );
};

export default CareerApplicationForm;
